import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log('🔍 Supabase Configuration Check:');
console.log('  URL:', supabaseUrl || '❌ MISSING');
console.log('  Anon Key exists:', !!supabaseAnonKey ? '✅ YES' : '❌ NO');

if (!supabaseUrl || !supabaseAnonKey) {
  const missingVars = [];
  if (!supabaseUrl) missingVars.push('VITE_SUPABASE_URL');
  if (!supabaseAnonKey) missingVars.push('VITE_SUPABASE_ANON_KEY');

  console.error(`❌ Missing Supabase environment variables: ${missingVars.join(', ')}`);
  console.error('The app will show a loading screen. Please check your .env file.');
}

// Validate URL format if provided
if (supabaseUrl) {
  try {
    new URL(supabaseUrl);
    console.log('✅ Supabase URL format is valid');
  } catch (error) {
    console.error(`❌ Invalid Supabase URL format: ${supabaseUrl}`);
  }
}

export const supabase = createClient<Database>(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    global: {
      headers: {
        'x-application-name': 'inventory-hub'
      }
    }
  }
);

// Connection test - non-blocking
if (supabaseUrl && supabaseAnonKey) {
  console.log('🔌 Testing Supabase connection...');

  supabase.from('profiles').select('count', { count: 'exact', head: true })
    .then(({ error }) => {
      if (error) {
        console.error('❌ Supabase connection test failed:', error);
      } else {
        console.log('✅ Supabase connection test successful');
      }
    })
    .catch((error) => {
      console.error('❌ Supabase connection test error:', error);
    });
}
